import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError } from "./responses/AxiosResponseHandler";
import { profileInfoUpdateRequestModel } from "../types";

class EditUserProfileInfoApi {
    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async editUserProfileInfo(userProfileInfo: profileInfoUpdateRequestModel) {
        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            if (authenticationResponse == null) {
                return undefined;
            }

            const response = await axios.post(
                `${this.authClient.getApiRoot()}/userProfileInfo/update`,
                userProfileInfo,
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
            };

        } catch (error) {
            const errorResponse = handleAxiosError(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage
            };
        }
    }
}

export default EditUserProfileInfoApi;